export const SUCCESS_STATUSES = [
  'SUCCESS',
  'CONFIRMED',
  'AUTHORIZED',
  'COMPLETED',
  'payment.succeeded',
];

export const FAILED_STATUSES = [
  'FAILED',
  'REJECTED',
  'CANCELED',
  'payment.canceled',
];

export const REFUNDED_STATUSES = ['REFUNDED', 'REFUND', 'refund.succeeded'];
